"use client"

import { useState } from "react"
import { useTranslation } from "../../../i18n"
import { ChevronDown, Search } from "lucide-react"

export default function MobilePaymentCard() {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState("today")

  return (
    <div className="w-[320px] bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
      {/* Header */}
      <div className="p-4 flex items-center justify-between bg-gray-50">
        <div className="flex items-center space-x-2">
          <div className="h-3 w-3 rounded-full bg-white border border-gray-200"></div>
          <span className="text-xs text-gray-500">ROCKET RIDES</span>
        </div>
        <div className="flex items-center">
          <Search className="h-4 w-4 text-gray-400" />
        </div>
      </div>

      {/* Magazine Subscription */}
      <div className="p-4 border-b border-gray-100">
        <div className="flex items-center space-x-3">
          <div className="h-12 w-12 bg-gradient-to-br from-purple-400 to-yellow-300 rounded-lg flex items-center justify-center">
            <div className="h-6 w-6 bg-white rounded-md"></div>
          </div>
          <div>
            <div className="text-sm font-medium">{t('bikeParking.payment.magazineTitle')}</div>
            <div className="text-xs text-gray-500">{t('bikeParking.payment.magazinePrice')}</div>
          </div>
        </div>
      </div>

      {/* Apple Pay Button */}
      <div className="p-4">
        <button className="w-full bg-black text-white py-2 rounded-md flex items-center justify-center space-x-2">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
            <path d="M17.6 13.2c-.02-1.3.6-2.5 1.6-3.2-1-.8-2.3-1.3-3.6-1.3-1.5-.2-3 .9-3.8.9-.8 0-2-.9-3.3-.9-1.7 0-3.3 1-4.1 2.5-1.8 3 .5 7.5 1.3 10 .8 1.2 1.8 2.6 3.2 2.5 1.3-.1 1.8-.8 3.3-.8 1.5 0 2 .8 3.3.8 1.4 0 2.3-1.2 3.1-2.4.6-.9 1.1-1.9 1.4-2.9-1.7-.7-2.8-2.4-2.8-4.2zM14.5 4.5c.8-1 1.2-2.2 1.1-3.5-1.2.1-2.3.7-3.1 1.7-.8.9-1.2 2.1-1.1 3.4 1.3 0 2.4-.6 3.1-1.6z" />
          </svg>
          <span>{t('bikeParking.payment.applePay')}</span>
        </button>

        <div className="mt-3 text-center text-sm text-gray-500">{t('bikeParking.payment.orCard')}</div>
      </div>

      {/* Payment Form */}
      <div className="p-4">
        <div className="mb-3">
          <div className="text-xs text-gray-500 mb-1">{t('bikeParking.payment.cardDetails')}</div>
          <div className="flex items-center justify-between border border-gray-300 rounded-md p-2">
            <div className="text-sm text-gray-400">{t('bikeParking.payment.cardNumber')}</div>
            <div className="flex items-center space-x-1">
              <img src="/visa-logo-generic.png" alt="Visa" className="h-5" />
              <img src="/mastercard-logo.png" alt="Mastercard" className="h-5" />
              <img src="/amex-logo.png" alt="Amex" className="h-5" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-3">
          <div className="border border-gray-300 rounded-md p-2">
            <div className="text-sm text-gray-400">{t('bikeParking.payment.expire')}</div>
          </div>
          <div className="border border-gray-300 rounded-md p-2">
            <div className="text-sm text-gray-400">{t('bikeParking.payment.cvc')}</div>
          </div>
        </div>

        <div className="mb-3">
          <div className="text-xs text-gray-500 mb-1">{t('bikeParking.payment.countryLabel')}</div>
          <div className="flex items-center justify-between border border-gray-300 rounded-md p-2">
            <div className="text-sm">{t('bikeParking.payment.countryUs')}</div>
            <ChevronDown className="h-4 w-4 text-gray-400" />
          </div>
        </div>

        <div className="mb-3">
          <div className="border border-gray-300 rounded-md p-2">
            <div className="text-sm text-gray-400">{t('bikeParking.payment.zip')}</div>
          </div>
        </div>

        <button
          className="w-full bg-navy-900 text-white py-2 rounded-md mt-2 disabled:opacity-50"
        >
          {t('bikeParking.payment.pay')}
        </button>
      </div>
    </div>
  )
}
